import { ChevronLeftIcon } from '@heroicons/react/24/solid'
import React from 'react'
import { useHistory } from 'react-router-dom'

function GoBackBtn() {
  const history = useHistory()
  return (
    <button onClick={() => history.goBack()} className='absolute top-10 left-10 flex items-center justify-center space-x-1 text-gray-600 transition-colors hover:underline hover:text-teal-800 px-4 py-2 rounded-full z-10'>
      <ChevronLeftIcon className="h-4" /> <span>Retour</span>
    </button>
  )
}

export default GoBackBtn